import { Component, output, viewChild } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';
import { ButtonModule } from 'primeng/button';
import { IconComponent } from '../../../icon/components/icon/icon.component';
import { PrimengButtonDirective } from '../../../button/directives/primeng-button.directive';
import { Icon } from '../../../icon/enums/icon';
import { Popover } from 'primeng/popover';

@Component({
  selector: 'app-table-header-item-action',
  imports: [
    ButtonModule,
    TooltipModule,
    IconComponent,
    PrimengButtonDirective,
    Popover,
  ],
  templateUrl: './table-header-item-action.component.html',
  styleUrls: ['./table-header-item-action.component.scss'],
})
export class TableHeaderItemActionComponent {
  public readonly sortClearEvent = output();

  protected readonly Icon = Icon;

  private readonly popover = viewChild.required(Popover);

  public handleClearSortClick(): void {
    this.sortClearEvent.emit();

    this.closePopover();
  }

  public handleTogglePopoverClick(event: MouseEvent): void {
    this.togglePopover(event);
  }

  private togglePopover(event: MouseEvent): void {
    this.popover().toggle(event);
  }

  private closePopover(): void {
    this.popover().hide();
  }
}
